import { render, staticRenderFns } from "./ExamProgress.vue?vue&type=template&id=145b61fc&scoped=true"
import script from "./ExamProgress.vue?vue&type=script&lang=js"
export * from "./ExamProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b61fc",
  null
  
)

export default component.exports